<template>
  <div>
    <Modal class="text-center font-weight-normal" v-if="showAfterAmp">
      <IconTrophy height="50" class="active mb-3" />
      <h3 class="h4">Congratulations!</h3>
      <p>You have successfully enabled AMP for your store.</p>

      <div class="mt-4 mb-4" v-if="false">
        <Streak class="active">
          <Alert icon="IconImportant" class="alert-attention d-inline-block mb-3 mt-3">
            <p class="font-weight-bold mb-0">Please read these points carefully</p>
          </Alert>
        </Streak>
      </div>

      <div class="media media-list-item mt-4 text-left">
        <IconCheck height="22" class="no-primary mr-2" />
        <div class="media-body">
          <h6 class="mt-0 mb-2">How to view AMP pages?</h6>
          <p class="mb-2">AMP pages will be visible to mobile users when they find your store on Google Search.</p>
          <p class="m-0">Alternatively, <a href="https://preview.superchargify.com/" rel="noopener" target="_blank" class="font-weight-normal">use our AMP Preview tool to view &amp; share AMP preview of your pages &rsaquo;</a></p>
        </div>
      </div>
      <div class="media media-list-item mt-4 text-left">
        <IconCheck height="22" class="no-primary mr-2" />
        <div class="media-body">
          <h6 class="mt-0 mb-2">AMP indexing may take up to a week</h6>
          <p class="m-0">Newly created AMP pages may take up to a week to appear on Google search results depending on how frequently Google indexes your store &amp; traffic your store receives.</p>
        </div>
      </div>
      <div class="media media-list-item mt-4 text-left">
        <IconCheck height="22" class="no-primary mr-2" />
        <div class="media-body">
          <h6 class="mt-0 mb-2">AMP Sitemap</h6>
          <p class="m-0"><router-link :to="{ name: 'amp_sitemap' }" class="font-weight-normal">Submit your AMP sitemap to Google Search Console to speedup discovery of your AMP pages &rsaquo;</router-link></p>
        </div>
      </div>
      <div class="media media-list-item mt-4 mb-4 text-left">
        <IconCheck height="22" class="no-primary mr-2" />
        <div class="media-body">
          <h6 class="mt-0 mb-2">{{shopObj.domain}}</h6>
          <p class="m-0">When users directly access your store, they will see your normal-Shopify themed store.</p>
        </div>
      </div>

      <div class="mt-4">
        <button class="btn btn-primary" @click="showAfterAmp = false" :disabled="!activateCloseButton">
          I understand<span v-if="!activateCloseButton"> ({{closeButtonTimer}})</span>
        </button>
      </div>
    </Modal>

    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Settings" />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 mb-0">Enable / Disable</h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <Alert icon="IconImportant" :class="{
              'alert-attention': db.status.amp,
              'alert-info': !db.status.amp
            }">
              <p class="mb-0">
                <span v-if="db.status.amp">After disabling AMP pages, it can take up to a few days to completely remove all the AMP results.</span>
                <span v-else>After enabling AMP, it can take up to a few days for AMP to appear on search engine results.</span>
              </p>
            </Alert>

            <label>Action</label>
            <div class="form-group form-check mb-0">
              <input type="checkbox" class="form-check-input" id="toggleAmp" v-model="status__amp">
              <label class="form-check-label" for="toggleAmp"><small>Enable AMP</small></label>
            </div>

            <div v-if="status__amp" class="mt-4">
              <label>Actions for Individual Resources</label>
              <div class="form-group form-check mb-3">
                <input type="checkbox" class="form-check-input" id="toggleAmpProducts" v-model="status__disable_amp_products">
                <label class="form-check-label" for="toggleAmpProducts"><small>Disable AMP for Products</small></label>
              </div>

              <div class="form-group form-check mb-3">
                <input type="checkbox" class="form-check-input" id="toggleAmpCollections" v-model="status__disable_amp_collections">
                <label class="form-check-label" for="toggleAmpCollections"><small>Disable AMP for Collections</small></label>
              </div>

              <div class="form-group form-check mb-0">
                <input type="checkbox" class="form-check-input" id="toggleAmpBlogPosts" v-model="status__disable_amp_blog_posts">
                <label class="form-check-label" for="toggleAmpBlogPosts"><small>Disable AMP for Blog posts</small></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="mt-5 mb-5" />

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 mb-0">AMP Links</h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <label>Action</label>
            <div class="form-group form-check mb-0">
              <input type="checkbox" class="form-check-input" id="miscobl" v-model="layout__outbound_links">
              <label class="form-check-label" for="miscobl"><small>If AMP page for the destination address is available, take users to the AMP page.</small></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 mb-0">AMP URL format</h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body font-weight-normal">
            <label>Products</label>
            <p class="word-break-break-all mb-1"><span class="text-muted">https://{{shopObj.domain}}</span>/a/sc/amp/products/<u class="text-danger">product-handle</u></p>
            <p class="word-break-break-all text-muted small mb-4">Replace <u class="text-danger">product-handle</u> with your product's handle</p>

            <label>Collections (Catalogue)</label>
            <p class="word-break-break-all mb-4"><span class="text-muted">https://{{shopObj.domain}}</span>/a/sc/amp/collections</p>

            <label>Collections</label>
            <p class="word-break-break-all mb-1"><span class="text-muted">https://{{shopObj.domain}}</span>/a/sc/amp/collections/<u class="text-danger">collection-handle</u></p>
            <p class="word-break-break-all text-muted small mb-4">Replace <u class="text-danger">collection-handle</u> with your collection's handle</p>

            <label>Blog posts</label>
            <p class="word-break-break-all mb-1"><span class="text-muted">https://{{shopObj.domain}}</span>/a/sc/amp/blogs/<u class="text-danger">blog-handle</u>/<u class="text-danger">article-handle</u></p>
            <p class="word-break-break-all text-muted small mb-0">Replace <u class="text-danger">blog-handle</u> &amp; <u class="text-danger">article-handle</u> with your blog &amp; article's handle, respectively</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 heading-badge mb-0">
          <span>Link to Superchargify</span>
          <UpgradeBadge targetPlan="pro" class="ml-2" noFreeUsers />
        </h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <label>Action</label>
            <div class="form-group form-check mb-0">
              <input type="checkbox" class="form-check-input" id="sclink" v-model="layout__superchargify_link" :disabled="disablePoweredBy">
              <label class="form-check-label" for="sclink"><small>Show "AMP &mdash; Powered by Superchargify" link at the bottom of AMP pages.</small></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 mb-0">Date</h2>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <label for="dateFormat">Format</label>
            <select type="text" class="form-control" id="dateFormat" v-model="language__date_format">
              <option value="%e %b %Y">1 Jul 2019</option>
              <option value="%e %B %Y">1 July 2019</option>
              <option value="%e/%b/%y">1/Jul/19</option>
              <option value="%e/%B/%Y">1/July/2019</option>
              <option value="%d/%m/%y">01/07/19</option>
              <option value="%a, %b %e %Y">Mon, Jul 1 2019</option>
              <option value="%b %e %Y">Jul 1 2019</option>
              <option value="%B %e %Y">July 1 2019</option>
              <option value="%b/%e/%y">Jul/1/19</option>
              <option value="%m/%d/%y">07/01/19</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard class="text-right" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'
import UpgradeBadge from '@/components/UpgradeBadge'
import Modal from '@/components/Modal'
import Streak from '@/components/Streak'

export default {
  mixins: [
    watchForChange(),
    mapMultiComputed('settings', [
      'status.amp',
      'status.disable_amp_products',
      'status.disable_amp_collections',
      'status.disable_amp_blog_posts',
      'layout.outbound_links',
      'layout.superchargify_link',
      'language.date_format'
    ])
  ],
  components: {
    UpgradeBadge,
    Modal,
    Streak
  },
  computed: {
    ...mapState([ 'shopObj', 'db', 'plan' ]),
    disablePoweredBy: function () {
      return !['pro', 'plus'].includes(this.plan)
    }
  },
  data: function () {
    return {
      showAfterAmp: false,
      closeButtonTimer: 6,
      activateCloseButton: false
    }
  },
  methods: mapActions([ 'saveMaster' ]),
  watch: {
    'db.status.amp': function (newVal, oldVal) {
      if (newVal) {
        clearInterval(this.closeButtonInterval)

        this.closeButtonTimer = 6
        this.activateCloseButton = false
        this.showAfterAmp = true

        this.closeButtonInterval = setInterval(() => {
          this.closeButtonTimer--

          if (this.closeButtonTimer === 0) {
            clearInterval(this.closeButtonInterval)
            this.activateCloseButton = true
          }
        }, 1500)
      }
    },
    'status__amp': function (newVal, oldVal) {
      this.status__disable_amp_products = false
      this.status__disable_amp_collections = false
      this.status__disable_amp_blog_posts = false
    },
    'status__disable_amp_products': function (newVal, oldVal) {
      const arr = [
        newVal,
        this.status__disable_amp_collections,
        this.status__disable_amp_blog_posts
      ]

      if (arr.every(a => !!a)) {
        this.status__amp = false
      }
    },
    'status__disable_amp_collections': function (newVal, oldVal) {
      const arr = [
        this.status__disable_amp_products,
        newVal,
        this.status__disable_amp_blog_posts
      ]

      if (arr.every(a => !!a)) {
        this.status__amp = false
      }
    },
    'status__disable_amp_blog_posts': function (newVal, oldVal) {
      const arr = [
        this.status__disable_amp_products,
        this.status__disable_amp_collections,
        newVal
      ]

      if (arr.every(a => !!a)) {
        this.status__amp = false
      }
    }
  }
}
</script>
